module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_vm._t("logo"), _vm._v(" "), _c('form-group', {
    attrs: {
      "size": "lg",
      "name": "loginform"
    },
    on: {
      "on-submit": _vm.submit
    }
  }, [_c('form-input', {
    attrs: {
      "holder": "请输入账号",
      "size": "lg",
      "icon": "people",
      "for": "loginform",
      "theme": "underline",
      "name": "phone",
      "required": true
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "holder": "请输入密码",
      "size": "lg",
      "icon": "lock",
      "for": "loginform",
      "theme": "underline",
      "name": "password",
      "required": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p3000"
  }, [_c('btn', {
    attrs: {
      "theme": "primary",
      "loading": _vm.loading,
      "block": true,
      "size": "lg",
      "submit": "loginform",
      "name": "登 录"
    }
  })], 1), _vm._v(" "), _vm._t("bottom")], 2), _vm._v(" "), _c('toast', {
    ref: "toast",
    attrs: {
      "type": _vm.type,
      "content": _vm.content
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51d07955!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/login/login.vue
// module id = 249
// module chunks = 3